// export const BaseUrl = "https://backendshineinlavender.quindl.com";

// export const BaseUrl = "https://ecom-api-quindl.onrender.com";

export const BaseUrl = "https://saree-backend-ec6j.onrender.com";
